module.exports = __webpack_public_path__ + "static/media/csv_cz.9ec25771.pdf";